import { render, staticRenderFns } from "./global-offers-v2.vue?vue&type=template&id=5dcfefce&scoped=true&"
import script from "./global-offers-v2.vue?vue&type=script&lang=js&"
export * from "./global-offers-v2.vue?vue&type=script&lang=js&"
import style0 from "./global-offers-v2.vue?vue&type=style&index=0&id=5dcfefce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dcfefce",
  null
  
)

export default component.exports